<template>
  <component :is="theme.components.BaseElementLayout" :el$="el$">
    <template slot="field">
      <slot name="prefix"></slot>
      <slot slot="label" name="label" :el$="el$"></slot>
      <div class="purchase_orders">
        <v-flex
          xs12
          v-for="(item, index) in this.purchase_orders"
          :key="item.POPH_Reference"
        >
          <v-card raised tile>
            <v-card-title
              style="height:30px;"
              color="gray"
              :key="`title${index}`"
            >
              {{ item.POPH_Reference }}
              <v-spacer></v-spacer>
              £{{ item.POPH_Total_Value_Ex_VAT_Home }}
            </v-card-title>
            <v-card-text
              class="purchase_order"
              v-if="purchase_orders_model[item.POPH_Reference]"
            >
              {{ item.SUPP_Name }}
              <v-flex xs-12>
                <label>
                  <v-checkbox
                    v-model="purchase_orders_model[item.POPH_Reference].used"
                    label="Used"
                    @click="handlePurchaseOrderModel"
                  ></v-checkbox>
                </label>
              </v-flex>
              <v-flex
                xs-12
                v-if="
                  purchase_orders_model[item.POPH_Reference].used &&
                    po_type == 'MAT'
                "
              >
                <v-label>GRN</v-label>
                <input
                  type="text"
                  :name="item.POPH_Reference"
                  :id="item.POPH_Reference"
                  class="form-control"
                  placeholder="Enter GRN Ref"
                  v-model="purchase_orders_model[item.POPH_Reference].grn"
                  @keyup="handlePurchaseOrderModel"
                />
              </v-flex>
              <v-flex
                xs-12
                v-if="
                  purchase_orders_model[item.POPH_Reference].used &&
                    po_type == 'HIR'
                "
              >
                <v-label>Off Hire Ref</v-label>
                <input
                  type="text"
                  :name="item.POPH_Reference"
                  :id="item.POPH_Reference"
                  class="form-control"
                  placeholder="Enter Off Hire Ref"
                  rules=""
                  v-model="
                    purchase_orders_model[item.POPH_Reference].off_hire_number
                  "
                  @keyup="handlePurchaseOrderModel"
                />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </div>
      <slot name="suffix"></slot>
    </template>
    <slot slot="info" name="info" :el$="el$">
      <v-btn color="success" @click="refreshPurchaseOrders()" flat icon>
        <v-icon>refresh</v-icon>
      </v-btn>
    </slot>
    <slot slot="before" name="before" :el$="el$"></slot>
    <slot slot="between" name="between" :el$="el$"></slot>
    <slot slot="error" name="error" :el$="el$"></slot>
    <slot slot="after" name="after" :el$="el$"></slot>
  </component>
</template>

<script>
import Vue from 'vue'
import BaseElement from '@laraform/laraform/src/mixins/BaseElement'
import BaseValidation from '@laraform/laraform/src/mixins/BaseValidation'
import TextElement from '@laraform/laraform/src/themes/bs4/components/elements/TextElement'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import lodash from 'lodash-es'
import deepdash from 'deepdash-es'
const _ = deepdash(lodash)

export default {
  name: 'PurchaseOrders',
  mixins: [BaseElement, BaseValidation, TextElement],
  data: () => ({
    purchase_orders: [],
    purchase_orders_model: {},
    loading: true
  }),
  mounted() {
    this.refreshPurchaseOrders()
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrders: 'calls/fetchPurchaseOrders'
    }),
    refreshPurchaseOrders() {
      const formData = this.getFormData[this.getSelectedFormId]
      let that = this
      this.loading = true
      this.purchase_orders = []
      this.fetchPurchaseOrders({
        id: this.getActiveCall.call_remote_id,
        call_assignment_id: this.getActiveCall.call_assignment_id,
        type: this.po_type ? this.po_type : 'MAT'
      }).then(result => {
        this.purchase_orders = result
        this.purchase_orders.map(p => {
          let pData = {
            used: false,
            grn: null,
            off_hire_number: null,
            po_number: p.POPH_Reference
          }
          Vue.set(this.purchase_orders_model, p.POPH_Reference, pData)
          let poValues = _.findValueDeep(formData, (val, key, parent) => {
            if (val == p.POPH_Reference) {
              Vue.set(this.purchase_orders_model, p.POPH_Reference, parent)
            }
          })
        })
        this.loading = false
      })
    },
    handlePurchaseOrderModel() {
      this.update(this.purchase_orders_model)
    }
  },
  computed: {
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      getFormData: 'calls/getFormData',
      getSelectedFormId: 'calls/getSelectedFormId'
    }),
    po_type() {
      return this.schema.po_type
    }
  },
  watch: {}
}
</script>
<style scoped lang="scss">
[type='number'] {
  width: 100%;
}
</style>
